import type {Query} from '@stripe-internal/sail/Search';
import type {TopicOption} from './getTopicOptions';

export const searchableTextFromOption = (option: TopicOption): string =>
  option.label.toLowerCase();

export function createTopicQuery(
  options: Array<TopicOption>,
): Query<TopicOption> {
  return (queryString: string) =>
    Promise.resolve(topicQuery(options, queryString));
}

function topicQuery(
  options: Array<TopicOption>,
  queryString: string,
): Array<TopicOption> {
  if (!queryString || queryString.length === 0) {
    return options;
  } else {
    const lowerQuery = queryString.toLowerCase();
    return options.filter(
      (o) => searchableTextFromOption(o).indexOf(lowerQuery) >= 0,
    );
  }
}
